const algoliasearch = require('algoliasearch/lite')
import instantsearch from 'instantsearch.js'
import { connectHits } from 'instantsearch.js/es/connectors'
import { searchBox } from 'instantsearch.js/es/widgets'

/*
 To keep this flexible, we're making both filtering
 widgets optional. They'll only render if their attributes
 have a DOM element
 */

import {
  configure,
} from '../../widgets/algolia/catalog'

import {
  categories,
  modality,
  solutions,
  taskGroup,
} from '../../widgets/algolia/catalog'

import {
  refinements,

} from '../../widgets/algolia/documentLibrary'

import { catalogConfig } from '../../config/algolia'

const widgets = [configure, categories, modality, solutions, taskGroup, refinements]

export default ($el) =>
  ({
    results: null,
    groupedResults: null,
    noResults: true,
    isLoaded: false,
    transform: '',
    el: $el,
    init() {
      const { index, appId, apiKey } = catalogConfig
      // const searchPlaceholder = 'Search.'
      const searchPlaceholder = this.el.querySelector('[data-widget="catalog-search"]').dataset
        .placeholder ?? 'Search...'

      // Start Algolia Client
      const algoliaClient = algoliasearch(appId, apiKey)
      // Build Search
      const search = instantsearch({
        indexName: index,
        searchClient: algoliaClient,
        searchFunction(helper) {
          helper.search()
        },
      })

      const structuredResults = connectHits(({ hits }) => {
        if (hits.length) {
          this.noResults = false
          this.results = hits
        } else {
          this.results = []
        }
      })

      /*
       * Add our widgets that are imported
       * from js/widgets/algolia/products/index.js
       */
      search.addWidgets([
        searchBox({
          container: '[data-widget="catalog-search"]',
          placeholder: searchPlaceholder,
          showReset: false,
          showSubmit: false,
          cssClasses: {
            root: ['form__algolia-search--simple'],
            input: ['form__algolia-search--simple-input'],
            form: ['form__algolia-search--simple-form'],
            submit: ['form__algolia-search--simple-submit'],
            reset: ['form__algolia-search--simple-reset'],
          },
        }),
        ...widgets,
        structuredResults(),
      ])

      // Start Search
      search.start()

      // search callbacks
      // @link: https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/#events
      // @link: https://community.algolia.com/instantsearch.js/v1/documentation/#events
      search.on('render', () => {
        this.isLoaded = true
      })
    },
  })
